import React from 'react'

const Profile = ({ height, width }) => {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14.8 14.8">
        <g transform="translate(-1.6 -1.6)">
          <path
            data-name="Path 934"
            d="M7 16.261v-.71A3.551 3.551 0 0 1 10.551 12h0a3.551 3.551 0 0 1 3.549 3.551v.71"
            transform="translate(-1.449 -2.898)"
            style={{
              strokeLinecap: 'round',
              fill: 'none',
              stroke: '#b1b1b1',
              strokeWidth: '.8px',
            }}
          />
          <path
            data-name="Path 935"
            d="M11.131 10.261A2.131 2.131 0 1 0 9 8.131a2.13 2.13 0 0 0 2.131 2.13z"
            transform="translate(-2.029 -1.159)"
            style={{
              strokeLinejoin: 'round',
              strokeLinecap: 'round',
              fill: 'none',
              stroke: '#b1b1b1',
              strokeWidth: '.8px',
            }}
          />
          <circle
            data-name="Ellipse 155"
            cx={7}
            cy={7}
            r={7}
            transform="translate(2 2)"
            style={{ fill: 'none', stroke: '#b1b1b1', strokeWidth: '.8px' }}
          />
        </g>
      </svg>
    </div>
  )
}

export default Profile
